module.exports = require('bindings')('xmljs');
